<template>
  <transition name="el-zoom-in-center">
    <el-menu :collapse="isCollapse" class="sidebar-menu" :default-active="activeMenu">
      <template v-for="(item,index) in routesLayout">
        <template v-if="!item.meta.hidden">
          <template v-if="item.children && item.children.length && item.children.filter(x=>!x.meta.hidden).length ">
            <el-submenu :key="index" :index='item.name'>
              <template slot="title">
                <font-awesome-icon :icon="item.meta.icon" style="width: 24px;" />
                <span slot="title" style="margin-left: 10px;">
                  {{ item.meta.title }}
                  <el-badge v-if="badge[item.name]" :value="badge[item.name]">
                  </el-badge>
                </span>
              </template>
              <!-- 二级别 -->
              <template v-for="(e,i) in item.children">
                <template v-if="!e.meta.hidden">
                  <template v-if="e.children && e.length && e.children.filter(x=>!x.meta.hidden).length ">
                  </template>
                  <template v-else>
                    <el-menu-item :key="i" :index='e.name' @click="$router.push({name:e.name})">
                      <font-awesome-icon :icon="e.meta.icon" style="width: 24px;" />
                      <span slot="title" style="margin-left: 10px;">
                        {{ e.meta.title }}
                        <el-badge v-if="badge[e.name]" :value="badge[e.name]">
                        </el-badge>
                      </span>
                    </el-menu-item>
                  </template>
                </template>
              </template>
            </el-submenu>
          </template>
          <template v-else>
            <el-menu-item :key="index" :index='item.name' @click="$router.push({name:item.name})">
              <font-awesome-icon :icon="item.meta.icon" style="width: 24px;" />
              <span slot="title" style="margin-left: 10px;">
                {{ item.meta.title }}
                <el-badge v-if="badge[item.name]" :value="badge[item.name]">
                </el-badge>
              </span>
            </el-menu-item>
          </template>
        </template>
      </template>
		<!-- <el-menu-item index='checkbill' @click="openturl()">
			<font-awesome-icon icon="align-justify" style="width: 24px;" />
			<span slot="title" style="margin-left: 10px;">
			运单轨迹
			</span>
		</el-menu-item> -->
    </el-menu>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	computed: mapGetters({
		badge: 'layout/badge',
	}),
	props: {
		isCollapse: {
			type: Boolean,
		},
	},
	data: () => ({
		activeMenu: '',
		routesLayout: '',
	}),
	async created() {
		for (const route of this.$router.options.routes) {
			if (route.name == 'Layout') {
				this.routesLayout = route.children
			}
		}
		let params = { pageNum: 1, pageSize: 1, timeType: 0, hidenInSettlement: '0', problemExists: 1, tenantId: localStorage.getItem('tenantId') }
		const res = await this.$api.billAdvanceAccount(params)
		this.$store.commit('layout/setBadge', { Questions: res.total })
	},
	watch: {
		'$route.name': {
			handler() {
				this.init()
			},
			immediate: true,
		},
	},
	methods: {
		init() {
			this.activeMenu = this.$route.name
		},
		// openturl(){
		// 	window.open('http://ffs.shippingassistant.cn:8080/ffs/checkbill/85689/checkbill.html')
		// }
	},
}
</script>

<style lang="scss">
.sidebar-menu {
	box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
}
.el-submenu {
	.el-submenu__title {
		background-color: #1f2f3e;
		color: #c0c4cc;
		.el-submenu__icon-arrow {
			color: #c0c4cc;
		}
	}
	.el-submenu__title:not(:last-child) {
		margin-bottom: 1px;
	}
	.el-submenu__title.is-active {
		background-color: #339999;
		color: white;
		.el-submenu__icon-arrow {
			color: white;
		}
	}
	.el-submenu__title:hover {
		background: #4edede;
		color: white;
		.el-submenu__icon-arrow {
			color: white;
		}
	}
}
.el-submenu:not(:last-child) {
	margin-bottom: 1px;
}
.el-menu {
	background-color: #000c17 !important;
	border: 0 !important;
	.el-menu-item {
		background-color: #1f2f3e;
		color: #c0c4cc;
	}
	.el-menu-item:not(:last-child) {
		margin-bottom: 1px;
	}
	.el-menu-item.is-active {
		background-color: #339999;
		color: white;
	}
	.el-menu-item:hover {
		background: #4edede;
		color: white;
	}
}
</style>
